import React from 'react'
import { createIcon } from '@chakra-ui/react'

export const ClockBase = (
  <path
    fill='currentColor'
    d='M2.5 10c0 4.136 3.364 7.5 7.5 7.5s7.5-3.364 7.5-7.5-3.364-7.5-7.5-7.5S2.5 5.864 2.5 10zM4 10c0-3.308 2.692-6 6-6s6 2.692 6 6-2.692 6-6 6-6-2.692-6-6zm5.7-3.75c-.249 0-.45.201-.45.45v3.6c0 .248.201.45.45.45h3.6c.248 0 .45-.201.45-.45v-.6c0-.249-.201-.45-.45-.45h-2.55V6.7c0-.249-.201-.45-.45-.45h-.6z'
  />
)

export const Clock = createIcon({
  displayName: 'Clock',
  viewBox: '0 0 20 20',
  path: ClockBase,
})
